
      <div class="ui-g-12">
          <div [kv-form-element]="{ label: 'loyalty.domiciliation_dsn_from', md: '6'}">
              <p-dropdown [options]="divisionSaleNetworkItemsFrom"
                          (onChange)="onDivisionSalesNetworkFromChange($event)"
                          [style]="{ 'width': '100%'}"
              >
              </p-dropdown>
          </div>
          <div [kv-form-element]="{ label: 'loyalty.domiciliation_store_from', md: '6'}">
              <p-dropdown [options]="storeItemsFrom"
                          [style]="{ 'width': '100%'}"
                          (onChange)="onStoreFromSelected($event)"
              >
              </p-dropdown>
          </div>


          <div *ngIf="cardDomiciliationStore != null">
              <div class="ui-g-12">
                  <div [kv-form-element]="{ label: 'loyalty.domiciliation_card_massive_store_total', md: '4'}">
                  </div>
                  <div class="ui-g-8" style="text-align: center;">
                      <label style="{width:100%;}" style="text-align: center;" >{{cardDomiciliationStore.length}}</label>
                  </div>
              </div>
              <div [kv-form-element]="{ label: 'loyalty.domiciliation_dsn_to', md: '6'}">
                  <p-dropdown [options]="divisionSaleNetworkItemsTo"
                              (onChange)="onDivisionSalesNetworkToChange($event)"
                              [style]="{ 'width': '100%'}"
                  >
                  </p-dropdown>
              </div>
              <div [kv-form-element]="{ label: 'loyalty.domiciliation_store_to', md: '6'}">
                  <p-dropdown [options]="storeItemsTo"
                              [style]="{ 'width': '100%'}"
                              [(ngModel)]="destinationStore"
                  >
                  </p-dropdown>
              </div>

              <div class="ui-g-12">
                  <div class="ui-g-4"></div>
                  <div class="ui-g-4">
                      <button pButton type="button" class="buttonExpand k-generic-btn" icon="fa fa-search" iconPos="left" [label]="'loyalty.domiciliation_massive_range_perform' | translate" (click)="performDomiciliation()" ></button>
                  </div>
                  <div class="ui-g-4"></div>
              </div>
          </div>


      </div>
  


// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-domiciliation/loyalty-domiciliation-massive-store.component.ts.LoyaltyDomiciliationMassiveStoreComponent.html